import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, Button } from '@material-ui/core';
import { ADD, EDIT, VIEW } from '../../../common/common';
import { timeFormatS, toMoney } from '../../../common/utils';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textField': {
        width: '45%',
        marginRight: '30px',
        backgroundColor: '#FFFFFF',
    },
    '& .textFieldF': {
        width: '100%',
        backgroundColor: '#FFFFFF',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#A1A1A1',
        margin: '20px 0',
        opacity: '0.12',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginTop: '18px',
    },
    '& .money': {
        fontSize: '16px',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

class DepositInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            payerName: "",
            payerEmail: "",
            description: "",
            date: "",
            id: -1,
            depositAmount: "",

            btnName: this.btnName(this.props.state)
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleModify = this.handleModify.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }
    render() {
        const {
            description,
            date,
            depositAmount,
        } = this.state;
        const showCreateBtn = () => {
            if (this.props.state === ADD) {
                return <Button variant="contained" color="primary" onClick={this.handleCreate}>{this.state.btnName}</Button>
            } else if (this.props.state === EDIT) {
                return <Button variant="contained" color="primary" onClick={this.handleModify}>{this.state.btnName}</Button>
            }
        }
        return (
            <Root>
                <div className="pageTitle">{this.props.title}</div>
                <div className="line"></div>
                {/* <div className="title">Payer Name</div>
                <TextField
                    disabled={this.isDisabled()}
                    className="textFieldF"
                    value={payerName}
                    margin="dense"
                    variant="outlined"
                    onChange={e => this.handleChange(e, 'payerName')}
                />
                <div className="title">Payer Email</div>
                <TextField
                    disabled={this.isDisabled()}
                    className="textFieldF"
                    value={payerEmail}
                    onChange={e => this.handleChange(e, 'payerEmail')}
                    margin="dense"
                    variant="outlined"
                /> */}
                <div className="title">Description</div>
                <TextField
                    disabled={this.isDisabled()}
                    className="textFieldF"
                    id="outlined-multiline-static"
                    multiline
                    rows="3"
                    value={description}
                    onChange={e => this.handleChange(e, 'description')}
                    margin="dense"
                    variant="outlined"
                />
                <div className="title">Date</div>
                <TextField
                    disabled={true}
                    className="textField"
                    value={timeFormatS(date)}
                    margin="dense"
                    variant="outlined"
                />
                <div className="title">Deposit Amount</div>
                <div className="h h-l">
                    <div className="money">$&nbsp;</div>
                    <TextField
                        disabled={this.isDisabled()}
                        className="textField"
                        value={depositAmount}
                        type="number"
                        margin="dense"
                        variant="outlined"
                        onChange={e => this.handleChange(e, 'depositAmount')}
                    />
                </div>
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                    {showCreateBtn()}
                </div>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        const { state, data } = this.props;
        console.log("data",data)
        if (state === VIEW || state === EDIT) {
            const invoice = data.invoice;
            const id = data.id;
            const deposit = data;
            const payerName = invoice ? invoice.payer : "";
            const payerEmail = invoice ? invoice.contact_email : "";
            const description = deposit ? deposit.description : "";
            const date = deposit ? deposit.action_time : "";
            const depositAmount = deposit.amount;

            console.log(date, depositAmount);
            this.setState(() => ({
                id,
                payerName,
                payerEmail,
                description,
                date,
                depositAmount,
            }))
        }
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    isMatterDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return true;
        }
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
    handleCreate() {
        const {
            description,
            depositAmount,
        } = this.state;
        let obj = {
            amount: depositAmount,
            date: new Date(),
            description,
        }
        console.log(obj)
        this.props.handleCreate(obj);
    }
    handleModify() {
        const {
            id,
            description,
            date,
            depositAmount,
        } = this.state;
        let obj = {
            id: id,
            amount: depositAmount,
            description,
        }
        console.log(obj)
        this.props.handleModify(obj);
    }
    mergeHandlers(attorneyArr, participantArr) {
        const aAddMembers = attorneyArr.addHandler;
        const pAddMembers = participantArr.addMembers;
        const aDelMembers = attorneyArr.delHandler;
        const pDelMembers = participantArr.delMembers;
        const addMembers = aAddMembers.concat(pAddMembers);
        const delMembers = aDelMembers.concat(pDelMembers);
        return { addMembers, delMembers };
    }
    editAttorney(handler) {
        const addHandler = handler;
        const delHandler = this.extDelAttorney();
        const addHandlerId = addHandler[0].handler_id;
        const delHandlerId = (delHandler.length > 0) ? delHandler[0].handler_id : "";
        const addTeamId = addHandler[0].handler_team_id;
        const delTeamId = (delHandler.length > 0) ? delHandler[0].handler_team_id : "";
        if (addHandler && delHandler) {
            if (addHandlerId === delHandlerId && addTeamId === delTeamId) {
                return { addHandler: [], delHandler: [] };
            } else {
                return { addHandler, delHandler }
            }
        }
    }
    extDelAttorney() {
        const { data } = this.props;
        if (!data) return [];
        const handlers = data.handler;
        if (!handlers) return [];
        let handlerObj = [];
        for (const obj of handlers) {
            if (obj.is_origin_attorney) {
                let newObj = {};
                newObj.handler_id = obj.user.id;
                newObj.handler_team_id = obj.team.id;
                newObj.is_origin_attorney = obj.is_origin_attorney;
                handlerObj.push(newObj);
                return handlerObj;
            }
        }
        return [];
    }
    handleCancel() {
        this.props.handleCancel();
    }
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleSelect(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    getHandleData(name) {
        const handlers = this.extAOrP("attorney");
        if (handlers.length <= 0) return "";
        const userObj = handlers[0].user;
        const deptObj = handlers[0].team;
        if (name === "office") {
            return deptObj ? deptObj.dept_info.office : "";
        } else if (name === "dept") {
            return deptObj ? deptObj.dept_info.id : "";
        } else if (name === "team") {
            return deptObj ? deptObj.id : "";
        } else if (name === "member") {
            return userObj ? userObj.id : "";
        }
    }
    userFormat() {
        const users = this.extAOrP();
        if (users) {
            let userList = [];
            for (const userObj of users) {
                let obj = {};
                obj.handler_id = userObj.user.id;
                obj.handler_team_id = userObj.team ? userObj.team.id : null;
                obj.is_origin_attorney = userObj.is_origin_attorney;
                userList.push(obj);
            }
            return userList;
        }
        return [];
    }
    extAOrP(type) {
        const { data } = this.props;
        if (!data) return [];
        let attorneyArr = [];
        let participateArr = [];
        const handlerArr = data.handler;
        if (!handlerArr) return [];
        for (const obj of handlerArr) {
            if (obj.is_origin_attorney) {
                attorneyArr.push(obj);
            } else {
                participateArr.push(obj);
            }
        }
        if (type === "attorney") {
            return attorneyArr;
        } else {
            return participateArr;
        }
    }
}

export default DepositInfo;